"use client"

import { Accordion } from "@base-ui/react/accordion"
import { PlusIcon, XMarkIcon } from "@heroicons/react/20/solid"
import Button from "../Button"

const faqItems = [
  {
    question: "What is near.com?",
    answer:
      "A platform where users can swap assets across 35+ networks at CEX speeds, trade privately, and access an exciting roadmap of new features you won't find anywhere else — all from a single, onchain account.",
  },
  {
    question: "How do I create an account?",
    answer:
      "Pick a wallet or passkey and you’re in. No signup, no email, no KYC. Your account is created instantly.",
  },
  {
    question: "How do swaps work?",
    answer:
      "Competing providers race to fill your order at the best price. Trades settle in seconds.",
  },
  {
    question: "What are Private deals?",
    answer:
      "Peer-to-peer trades with custom terms. Want to trade BTC for ZEC with someone? Create the deal, share a link, they accept, and both sides get exactly what was agreed — guaranteed by smart contracts.",
  },
  {
    question: "What’s coming next?",
    answer:
      "Confidential activity (a game changer), access yield on idle assets, AI-assisted financial management, tokenized real-world assets, virtual bank accounts, debit cards, and more! The super-app among super-apps!",
  },
  {
    question: "Can my business integrate?",
    answer: (
      <>
        Yes — by integrating our technology, Ledger, SwapKit, and many others
        have processed over $13B in cross-chain swaps. Interested?{" "}
        <button
          type="button"
          className="text-gray-900 underline hover:text-gray-700"
          onClick={() => {
            if (typeof window !== "undefined" && window.Beacon) {
              window.Beacon("open")
            }
          }}
        >
          Reach out!
        </button>
      </>
    ),
  },
  {
    question: "Need help?",
    answer:
      "You got questions? We got answers! Click the support icon anytime. We usually respond within 24 hours.",
  },
]

const Faq = () => (
  <section className="mx-auto mt-24 grid w-full max-w-lg gap-10 px-5 pb-24 md:mt-32 md:pb-32 lg:max-w-[1064px] lg:grid-cols-3">
    <div>
      <h2 className="-tracking-[0.01em] text-balance font-semibold text-2xl/7 text-gray-900 sm:text-3xl/8">
        Common questions
      </h2>
      <p className="mt-1 text-balance font-medium text-base/5 text-gray-500 sm:mt-2 sm:text-lg/6">
        Can&rsquo;t find your answer? Send us a note, and we&rsquo;ll be in
        touch.
      </p>
      <Button
        size="lg"
        variant="secondary"
        className="mt-4"
        onClick={() => {
          if (typeof window !== "undefined" && window.Beacon) {
            window.Beacon("open")
          }
        }}
      >
        Contact support
      </Button>
    </div>

    <Accordion.Root
      multiple
      className="col-span-1 divide-y divide-gray-200 border-gray-200 border-y lg:col-span-2"
    >
      {faqItems.map(({ question, answer }) => (
        <Accordion.Item key={question} className="relative">
          <Accordion.Header>
            <Accordion.Trigger className="group peer relative z-10 flex w-full items-center justify-between gap-6 py-5 text-left focus-visible:outline-none">
              <span className="-tracking-[0.01em] font-semibold text-gray-900 text-lg/5 sm:text-xl/6">
                {question}
              </span>
              <PlusIcon className="block size-5 text-gray-500 group-data-panel-open:hidden" />
              <XMarkIcon className="hidden size-5 text-gray-500 group-data-panel-open:block" />
            </Accordion.Trigger>
            <div
              className="-inset-y-px -inset-x-4 absolute rounded-2xl border border-transparent peer-focus-visible:border-gray-200 peer-focus-visible:bg-gray-100"
              aria-hidden="true"
            />
          </Accordion.Header>
          <Accordion.Panel className="-mt-3 relative pr-12 pb-4 font-medium text-base/6 text-gray-500">
            {answer}
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  </section>
)

export default Faq
